import { useQuery } from '@tanstack/react-query'

import { queryByIdsPaymentRequests } from '@src/api'
import { DefaultApiQueryByIdsPaymentRequestsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

/**
 * Although treated as a fetch, the HTTP Method actually executed is POST.
 */
export const useFetchQueryByIdsPaymentRequests = (
  params: DefaultApiQueryByIdsPaymentRequestsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled:
      !!params.organizationId && !!params.queryByIdsPaymentRequestsRequest,
    queryFn: () => queryByIdsPaymentRequests(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.QUERY_BY_IDS_PAYMENT_REQUESTS,
      params.organizationId,
      params.queryByIdsPaymentRequestsRequest,
    ],
  })
}
